import flush from 'just-flush';

type Options = {
  id: string;
  url: string;
  dateStart: Date;
  title: string;
  dateEnd?: Date;
  location?: string;
  contact?: {
    name: string;
    email: string;
  };
};

export default function createIcsFile({
  id,
  url,
  title,
  location,
  dateStart,
  dateEnd,
  contact
}: Options) {
  const text = flush([
    `BEGIN:VCALENDAR`,
    `VERSION:2.0`,
    `CALSCALE:GREGORIAN`,
    `BEGIN:VEVENT`,
    `DTSTAMP:${dateStart
      .toISOString()
      .replace(/\.\d+Z$/, 'Z')
      .replace(/[^\dTZ]/g, '')}`,
    `DTSTART;TZID=UTC:${dateStart
      .toISOString()
      .replace(/\.\d+Z$/, 'Z')
      .replace(/[^\dTZ]/g, '')}`,
    `UID:${id}`,
    `URL:${url}`,
    `SUMMARY:${title}`,
    dateEnd
      ? `DTEND;TZID=UTC:${dateEnd.toISOString().replace(/[^\dTZ]/g, '')}`
      : null,
    location ? `LOCATION:${location}` : null,
    contact ? `ORGANIZER;CN=${contact.name}:MAILTO:${contact.email}` : null,
    `STATUS:CONFIRMED`,
    `CLASS:PUBLIC`,
    `END:VEVENT`,
    `END:VCALENDAR`
  ]).join('\n');

  const blob = new Blob([text], {
    type: 'text/calendar'
  });

  return blob;
}
